/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

export default ({ icon, label, children }) => (
  <li>
    <a className="has-arrow" href="#" aria-expanded="false">
      <i className={`fa fa-${icon}`} style={{ color: '#0077FF' }} />
      <span className="nav-label">{label}</span>
    </a>
    <ul className="nav nav-second-level">{children}</ul>
  </li>
);
